/** Hamssah showroom — Prestigia, Fès-Médina */
export const SHOWROOM_ADDRESS_LINE =
  'Prestigia Numéro 5, Lot 23, Champs De Course, 30000 — Fès-Médina';

export function showroomMapSearchUrl(address = SHOWROOM_ADDRESS_LINE): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
}

export function showroomMapEmbedUrl(address = SHOWROOM_ADDRESS_LINE): string {
  return `https://www.google.com/maps?q=${encodeURIComponent(address)}&output=embed`;
}
